module.exports = __webpack_public_path__ + "static/media/number-2-normal.0453303d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/numbers/number-2-normal.svg
// module id = 1309
// module chunks = 0